import { Component, computed, inject, input, output } from "@angular/core"
import { NgOptimizedImage } from "@angular/common"
import { CarouselImage } from "../intro.model"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    NgOptimizedImage,
  ],
  providers: [],
  standalone: true,
  template: `
    <div
      style="position: absolute; top: 25px; left: 0; width: 100%; height: 100%; transition: z-index 250ms"
      [style.z-index]="style().zIndex"
    >
      <img
        style="transition: 500ms cubic-bezier(0.17, 0.67, 0.55, 1.43)"
        [style.opacity]="style().opacity"
        [style.transform]="style().transform"
        class="bg-transparent relative left-0 max-h-full"
        
        [ngSrc]="imageSrc()"
        [alt]="imageObject().alt"
        width="350"
        height="350"
        (click)="changeImage.emit(imageObject())"
      />
    </div>

  `,
  selector: "e2e-carousel-image",
})
export class CarouselImageComponent {
  private storageService = inject(StorageService)

  imageObject = input.required<CarouselImage>()
  index = input.required<number>()
  carouselIndex = input.required<number>()
  length = input.required<number>()

  changeImage = output<CarouselImage>()

  imageSrc = computed(() =>
    this.storageService.getFileUrl(this.imageObject()?.src)
  )

  style = computed(() => {
    const sliderIndex = this.carouselIndex()
    switch (this.index()) {
      case sliderIndex - 2: // previous
        return {
          opacity: 0.3,
          transform: "translateX(-60%) translateY(40%) scale(0.6)",
          zIndex: 1,
        }
      case sliderIndex - 1: // previous
        return {
          opacity: 0.3,
          transform: "translateX(-30%) translateY(10%) scale(0.8)",
          zIndex: 2,
        }
      case sliderIndex: // selected
        return {
          opacity: 1,
          transform: "translateX(0%) translateY(-10%) scale(1)",
          zIndex: 3,
        }
      case sliderIndex + 1: // next
        return {
          opacity: 0.3,
          transform: "translateX(30%) translateY(10%) scale(0.8)",
          zIndex: 2,
        }
      case sliderIndex + 2: // next
        return {
          opacity: 0.3,
          transform: "translateX(60%) translateY(40%) scale(0.6)",
          zIndex: 1,
        }
      default: {
        if (this.index() < sliderIndex) {
          return {
            opacity: 0,
            transform: "translateX(-80%) translateY(60%) scale(0.4)",
            zIndex: 0,
          }
        } else {
          return {
            opacity: 0,
            top: 50,
            transform: "translateX(80%) translateY(60%) scale(0.4)",
            zIndex: 0,
          }
        }
      }
    }
  })

}
